import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, apiErrorMessage } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(undefined); // undefined = loading, null = not authed
    const [error, setError] = useState("");

    const fetchMe = useCallback(async () => {
        // CRITICAL: If returning from Emergent Google OAuth callback, skip the /me check.
        // AuthCallback will exchange the session_id and establish the session first.
        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
            setUser(null);
            return;
        }
        try {
            const { data } = await api.get("/auth/me");
            setUser(data.user);
        } catch (e) {
            setUser(null);
        }
    }, []);

    useEffect(() => { fetchMe(); }, [fetchMe]);

    const login = async (email, password) => {
        setError("");
        try {
            const { data } = await api.post("/auth/login", { email, password });
            setUser(data.user);
            return { ok: true };
        } catch (e) {
            const msg = apiErrorMessage(e);
            setError(msg);
            return { ok: false, error: msg };
        }
    };

    const logout = async () => {
        try { await api.post("/auth/logout"); } catch (_) {}
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, error, login, logout, refresh: fetchMe }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}
